var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"data-tf-live":"01HSXTPRNPT2ZDYNR5ZSPRMVDG"}}),_c('script',{attrs:{"type":"application/javascript","src":"//embed.typeform.com/next/embed.js"}})])
}]

export { render, staticRenderFns }